import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { useTranslate } from '../lib/i18n';

interface SessionPasswordCodeProps {
  sessionPassword?: { code: string; expiresAt: string | null } | null;
  showTitle?: boolean;
}

const SessionPasswordCode = ({ sessionPassword, showTitle = true }: SessionPasswordCodeProps) => {
  const t = useTranslate();
  const [passwordCopied, setPasswordCopied] = useState(false);

  if (!sessionPassword) {
    return null;
  }

  const handleCopyPassword = async () => {
    try {
      await navigator.clipboard.writeText(sessionPassword.code);
      setPasswordCopied(true);
      setTimeout(() => setPasswordCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy password:', error);
    }
  };

  return (
    <div className="space-y-2">
      {showTitle && (
        <div className="text-sm text-muted-foreground">
          {t('survey.sessionPassword').toUpperCase()}
        </div>
      )}
      <div className="flex items-center justify-between border rounded-md bg-muted px-3 py-2">
        <code className="text-xl font-mono">{sessionPassword.code}</code>
        <button type="button" aria-label="Copy" onClick={handleCopyPassword}>
          {passwordCopied ? (
            <Check size={16} className="cursor-pointer" />
          ) : (
            <Copy size={16} className="cursor-pointer" />
          )}
        </button>
      </div>
    </div>
  );
};

export default SessionPasswordCode;
